import { useEffect, useState } from 'react';
import { useSettings, type LayoutId } from '../store/settings';

/** True while the window is taller than it is wide (rotated tablet / portrait-mounted TV). */
export function usePortrait(): boolean {
  const [portrait, setPortrait] = useState(() => window.innerHeight > window.innerWidth);
  useEffect(() => {
    const onResize = () => setPortrait(window.innerHeight > window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return portrait;
}

export const isPortraitLayout = (l: LayoutId) => l === 'portrait-stack' || l === 'portrait-glass';

/** The layout to draw now: the portrait choice on tall screens, otherwise the main one. */
export function useEffectiveLayout(): LayoutId {
  const layout = useSettings((s) => s.layout);
  const layoutPortrait = useSettings((s) => s.layoutPortrait);
  const portrait = usePortrait();
  return portrait && layoutPortrait !== 'same' ? layoutPortrait : layout;
}
